module.exports = __webpack_public_path__ + "static/media/gp1.8c54780c.png";